import axios from "axios";
import Swal from "sweetalert2";

axios.interceptors.response.use(null, error => {
  console.log(error.response);
  console.log(error);
  Swal.fire({
    title: "Unexpected error occured",
    html: error.response.data.errorMessage + "<br/>Please, try again later",
    type: "warning",
    confirmButtonText: "OK"
  });
  return Promise.reject(error);
});
function setJwt(token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt
};
